import { useState } from 'react'
import * as Yup from 'yup'
import { Form, Formik, Field } from 'formik'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'
import { toast } from 'react-toastify'

import Modal from 'components/Modal'
import TextBox from 'components/TextBox'
import ToggleButton from 'components/ToggleButton'

import {
  getCustomPaymentType,
  getIsCustomPaymentTypesLoading,
} from 'store/CustomPaymentTypes/selectors'
import {
  getCurrentVenueUuid,
  getCurrentVenue,
} from 'store/Venues/selector'
import {
  createCustomPaymentType,
  updateCustomPaymentType,
  deleteCustomPaymentType,
} from 'store/CustomPaymentTypes/actions'

const CustomTendersForm = () => {
  const [showValidationErrors, setShowValidationErrors] =
    useState(true)

  const history = useHistory()
  const dispatch = useDispatch()
  const { state: urlQueryParamsState } = useLocation()

  const customTenderUuid = urlQueryParamsState?.customTenderUuid

  const venueUuid = useSelector(getCurrentVenueUuid)
  const currentVenue = useSelector(getCurrentVenue)
  const customPaymentType = useSelector((state) =>
    getCustomPaymentType(state, customTenderUuid)
  )
  const isLoading = useSelector(getIsCustomPaymentTypesLoading)

  const { displayName, active, noop, taxable, uuid } =
    customPaymentType

  const isNewCustomTender = customTenderUuid === 'new'

  const modalTitle = isNewCustomTender
    ? 'Add Custom Tender'
    : 'Edit Custom Tender'

  const initialValues = {
    displayName: displayName ?? '',
    taxable: taxable ?? true,
    active: active ?? false,
    noop: noop ?? true,
  }

  const validationSchema = Yup.object().shape({
    displayName: Yup.string().required('Required'),
  })

  const disableUpdateButton = (dirty, errors) => {
    const disableButton =
      !dirty || (showValidationErrors && !isEmpty(errors))

    return disableButton
  }
  const onCloseModal = () =>
    history.push({ state: { customTenderUuid: null } })

  const onDelete = (e) => {
    e.preventDefault()

    dispatch(deleteCustomPaymentType(uuid)).then((response) => {
      // if action payload is empty, then stay on the same page
      if (isEmpty(response?.payload)) return

      history.push({ state: { customTenderUuid: null } })
    })
  }

  const onSubmit = (values) => {
    const additionalData = {
      venueUuid,
      organizationName: currentVenue.label,
      authorize: true,
    }

    const newCustomTenderData = {
      customPaymentTypes: [{ ...values, ...additionalData }],
    }

    const editCustomTenderdata = {
      customPaymentTypes: [{ ...values, ...additionalData, uuid }],
    }

    if (isNewCustomTender) {
      dispatch(createCustomPaymentType(newCustomTenderData)).then(
        (response) => {
          // if action payload is empty, then stay on the same page
          if (isEmpty(response?.payload)) return

          history.push({ state: { customTenderUuid: null } })
        }
      )
    } else {
      dispatch(updateCustomPaymentType(editCustomTenderdata)).then(
        (response) => {
          // if action payload is empty, then stay on the same page
          if (isEmpty(response?.payload)) return

          history.push({ state: { customTenderUuid: null } })
        }
      )
    }
  }

  return (
    <Modal
      className="-narrow"
      title={modalTitle}
      onClose={onCloseModal}
      isLoading={isLoading}
      onRequestClose={onCloseModal}
    >
      <div className="modal-body">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ dirty, errors }) => (
            <Form className="custom-tender-settings">
              <div className="item-settings">
                <div className="modal-paragraph -more-space">
                  Custom Tenders are visible on all POS menus and
                  devices
                </div>
                <div className="text-field">
                  <Field
                    component={TextBox}
                    label="Display Name"
                    name="displayName"
                    disabled={!isNewCustomTender}
                  />
                </div>
                {/* This will be uncomment in future use */}
                {/* Remember to uncomment related tests */}
                {/* <div className="content-wrapper -flags-wrapper">
                <span className="content-header">Taxable</span>
                <span className="content-value">
                  <Field
                    component={ToggleButton}
                    name="taxable"
                    type="checkbox"
                  />
                </span>
              </div> */}
                {/* <div className="content-wrapper -flags-wrapper">
                <span className="content-header">No-Op Tender</span>
                <span className="content-value">
                  <Field
                    component={ToggleButton}
                    name="noop"
                    type="checkbox"
                  />
                </span>
              </div> */}
                <div className="content-wrapper -flags-wrapper">
                  <span className="content-header">Active</span>
                  <span className="content-value">
                    <Field
                      component={ToggleButton}
                      name="active"
                      type="checkbox"
                    />
                  </span>
                </div>
                {/* {!isNewCustomTender && (
                  <button
                    type="button"
                    className="btn -outline -block -danger"
                    onClick={onDelete}
                  >
                    Delete Custom Tender
                  </button>
                )} */}
                <div className="btn-wrapper">
                  <button
                    className="btn -update"
                    onClick={() => setShowValidationErrors(true)}
                    disabled={disableUpdateButton(dirty, errors)}
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default CustomTendersForm
